module.exports = __webpack_public_path__ + "img/bg-request-refund-success.26ac5564.png";